import React from "react";
import styles from "../Sitemap/Sitemap.module.scss";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";

const SitemapSection = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Sitemap", link: "/disclaimer" },
  ];
  return (
    <div className="container">
      <BreadCrumb menu={breadcrumb} />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        <div className={`${styles.SitemapSection} row mt-5`}>
          <div className={`${styles.mainhead} heading`}>Sitemap</div>
          <div>
            <ul className={`${styles.listsBox}`}>
              {/* <li className={styles.mainLink}>
              <a href="/" className={`${styles.link} subHeading`}>
                Homepage
              </a>
            </li> */}
              <li className={styles.mainLink}>
                <a href="/about-us" className={`${styles.link} subHeading`}>
                  About Us
                </a>
                <ul className={styles.subLinkDiv}>
                  <li className="subHeading">
                    <a href="/about-us">Overview</a>
                  </li>
                  <li className="subHeading">
                    <a href="/about-us/mission-vision">Mission & Vision</a>
                  </li>

                  <li className="subHeading">
                    <a href="/about-us/award-achievement">
                      Awards & Achievements
                    </a>
                  </li>
                  {/* <li className="subHeading">
                  <a href="/about-us/our-leadership-team">Leadership Team</a>
                </li> */}
                  <li className="subHeading">
                    <a href="/about-us/corporate-social-responsibility">
                      Corporate Social Responsibility
                    </a>
                  </li>
                </ul>
              </li>
              <li className={styles.mainLink}>
                <a
                  href="/our-businesses"
                  className={`${styles.link} subHeading`}
                >
                  Our Businesses
                </a>
                <ul className={styles.subLinkDiv}>
                  <li className="subHeading">
                    <a href="/our-businesses">Overview</a>
                  </li>
                  <li className="subHeading">
                    <a href="/our-businesses/domestic-retail">
                      Domestic Retail
                    </a>
                  </li>
                  <li className="subHeading">
                    <a href="/our-businesses/institutional-business">
                      Institutional Business
                    </a>
                  </li>
                  <li className="subHeading">
                    <a href="/our-businesses/international-retail">
                      International Retail
                    </a>
                  </li>
                </ul>
              </li>
              <li className={styles.mainLink}>
                <a href="/investors" className={`${styles.link} subHeading`}>
                  Investors
                </a>
                <ul className={styles.subLinkDiv}>
                  <li className="subHeading">
                    <a href="/investors">Overview</a>
                  </li>
                  <li className="subHeading">
                    <a href="/investors/news-and-notifications">
                      News & Notifications
                    </a>
                  </li>
                  <li className="subHeading">
                    <a href="/investors/board-of-directors">
                      Board of Directors
                    </a>
                  </li>
                  <li className="subHeading">
                    <a href="/investors/shareholders">Shareholders</a>
                  </li>
                  <li className="subHeading">
                    <a href="/investors/filings-with-stock-exchanges">
                      Filings with Stock Exchanges
                    </a>
                  </li>
                  <li className="subHeading">
                    <a href="/investors/results-and-reports">
                      Results & Reports
                    </a>
                  </li>
                </ul>
              </li>
              <li className={styles.mainLink}>
                <a
                  href="/news-and-media/press-releases"
                  className={`${styles.link} subHeading`}
                >
                  News & Media
                </a>
                <ul className={styles.subLinkDiv}>
                  <li className="subHeading">
                    <a href="/news-and-media/press-releases">Press Releases</a>
                  </li>
                  <li className="subHeading">
                    <a href="/news-and-media/aptech-in-news">Aptech in News</a>
                  </li>
                  <li className="subHeading">
                    <a href="/news-and-media/media-kit">Media Kit</a>
                  </li>
                </ul>
              </li>
              <li className={styles.mainLink}>
                <a
                  href="/careers-with-aptech"
                  className={`${styles.link} subHeading`}
                >
                  Careers with Aptech
                </a>
              </li>
              <li className={styles.mainLink}>
                <a
                  href="/partner-with-aptech"
                  className={`${styles.link} subHeading`}
                >
                  Partner with Aptech
                </a>
              </li>
              <li className={styles.mainLink}>
                <a href="/contact-us" className={`${styles.link} subHeading`}>
                  Contact Us
                </a>
              </li>
              <li className={styles.mainLink}>
                <a href="/our-blogs" className={`${styles.link} subHeading`}>
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SitemapSection;
